/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const listUsersParamsQueryMax = 100;

export const listUsersParamsTeamIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const listUsersParamsCorporateIdentityIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const listUsersParamsCursorMax = 512;

export const listUsersParamsCursorRegExp = new RegExp('^[A-Za-z0-9_-]+$');
export const listUsersParamsLimitDefault = 50;
export const listUsersParamsLimitMax = 100;

export const ListUsersParams = zod.object({
  query: zod.string().max(listUsersParamsQueryMax).optional(),
  role: zod.enum(['none', 'Agent', 'Admin']).optional(),
  corporateState: zod.enum(['active', 'deactivated']).optional(),
  teamId: zod.uuid().regex(listUsersParamsTeamIdRegExp).optional(),
  corporateIdentityId: zod.uuid().regex(listUsersParamsCorporateIdentityIdRegExp).optional(),
  contactReady: zod.string().optional(),
  cursor: zod
    .string()
    .min(1)
    .max(listUsersParamsCursorMax)
    .regex(listUsersParamsCursorRegExp)
    .optional(),
  limit: zod.int().min(1).max(listUsersParamsLimitMax).default(listUsersParamsLimitDefault),
});

export type ListUsersParams = zod.input<typeof ListUsersParams>;
export type ListUsersParamsOutput = zod.output<typeof ListUsersParams>;
